import { render, staticRenderFns } from "./AddMasterPayment.vue?vue&type=template&id=3627a2b7&scoped=true&"
import script from "./AddMasterPayment.vue?vue&type=script&lang=js&"
export * from "./AddMasterPayment.vue?vue&type=script&lang=js&"
import style0 from "./AddMasterPayment.vue?vue&type=style&index=0&id=3627a2b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3627a2b7",
  null
  
)

export default component.exports